import fetch from '../../fetch';
import { IHttpMethod } from '../../../ts/enums/fetch-enums';

const controllerName = 'notifications';

export type NotificationCategory =
  | 'EMPLOYEE_DOCUMENT_EXPIRING'
  | 'CLOCKIN_LATE'
  | 'CLOCKIN_INSUFFICIENT_REST'
  | 'CLOCKIN_INCONSISTENCY'
  | 'EMPLOYEE_ABSENCE'
  | 'PAYROLL_CLOSING_SOON'
  | 'PAYROLL_CLOSED'
  | 'PAYROLL_LATE_CLOCKIN_ADJUSTMENT'
  | 'PAYROLL_ROUTINE_ERROR'
  | 'PROPOSAL_DELIVERY_DEADLINE_EXPIRING'
  | 'PROPOSAL_VALIDITY_EXPIRING'
  | 'CRONOGRAMA_TASK_DEADLINE'
  | 'SERVICE_WORK_COMPLETION_REQUESTED'
  | 'RDO_PENDING_VALIDATION'
  | 'PURCHASE_ORDER_CONFIRMED'
  | 'VEHICLE_LINK_REQUESTED'
  | 'VEHICLE_DAMAGE'
  | 'CUSTOMER_DOCUMENT_EXPIRING'
  | 'ST_DOCUMENT_EXPIRING'
  | 'GERAL';

export interface INotification {
  id?: string;
  content: string;
  userId: string;
  createdAt?: string;
  read?: boolean;
  link?: string;
  category?: NotificationCategory;
}

export interface IListNotificationsParams {
  page?: number;
  limit?: number;
  category?: NotificationCategory;
  search?: string;
  startDate?: string;
  endDate?: string;
}

export interface IListNotificationsResponse {
  items: INotification[];
  total: number;
  page: number;
  limit: number;
}

export async function listNotifications(params: IListNotificationsParams = {}) {
  return await fetch<IListNotificationsResponse>({
    method: IHttpMethod.GET,
    path: `${controllerName}`,
    params,
  });
}

export async function getUnreadNotificationsCount() {
  return await fetch<{ count: number }>({
    method: IHttpMethod.GET,
    path: `${controllerName}/unread-count`,
  });
}

export async function markNotificationAsRead(notificationId: string) {
  return await fetch({
    method: IHttpMethod.POST,
    path: `${controllerName}/read/${notificationId}`,
  });
}

export async function markAllNotificationsAsRead() {
  return await fetch({
    method: IHttpMethod.POST,
    path: `${controllerName}/read-all`,
  });
}
